import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {Goto} from "./goto";

export const gotoLoader = function (options = {}) {
    componentLoader(componentConfig(Goto, Goto.config.componentTypeKey, Goto.config.baseHtmlClass), options);
};
